<template>
    <v-container>
        <div>
            <v-alert
                    id="alertComp"
                    v-model="alert"
                    dismissible
                    type="success"
            >
                Proceso de exportación creado exitosamente.
            </v-alert>
        </div>
        <v-layout>
            <v-flex>
                <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                >
                  <v-select
                      :items="$store.state.companies"
                      v-model="activity.company"
                      label="Compañia"
                      item-value="id"
                      item-text="name"
                      :rules="[v => !!v || 'Campo requerido']"
                      return-object
                      persistent-hint
                      required
                      @change="changeCompany"
                  >
                  </v-select>
                      <v-autocomplete
                          :items="this.activitiesConfig"
                          v-model="activity.activityConfigurationCompany"
                          label="Actividad"
                          item-value="id"
                          item-text="codeName"
                          :rules="[v => !!v || 'Campo requerido']"
                          return-object
                          persistent-hint
                          required
                      >
                      </v-autocomplete>

                    <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="fechaInicio"
                                    label="Fecha inicio"
                                    readonly
                                    v-on="on"
                                    required
                                    :rules="[v => !!v || 'Fecha inicio es requerida']"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaInicio" @input="menu = false"></v-date-picker>
                    </v-menu>

                    <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="fechaFin"
                                    label="Fecha fin"
                                    readonly
                                    v-on="on"
                                    required
                                    :rules="[v => !!v || 'Fecha fin es requerida']"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaFin" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                  <v-select
                      :items="estados"
                      v-model="estado"
                      label="Seleccione el estado"
                      required
                      :rules="[v => !!v || 'Estado es requerido']"
                  ></v-select>

                </v-form>
                <div class="text-xs-center">
                    <v-btn color="primary"
                           dark
                           @click="searchData">Buscar
                    </v-btn>
                </div>
              <h3 class="primary--text">Lista de actividades realizadas</h3>
              <v-data-table
                  :headers="headers"
                  :items="this.activities"
                  class="elevation-1"
                  sort-icon="mdi-menu-down"
                  :search="search"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ getFormattedDate(props.item.date) }}</td>
                  <td class="text-xs-left">{{ props.item.activityConfigurationCompany.company.name }}</td>
                  <td class="text-xs-left">{{ props.item.activityConfigurationCompany.code }} {{ props.item.activityConfigurationCompany.name }}</td>
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.description }}</td>
                  <td class="text-xs-left">{{ props.item.status }}</td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  No se han encontrado resultados para "{{ search }}".
                </v-alert>
              </v-data-table>
              <div v-if="this.activities.length>0">
                <h2>Total actividades: {{countTareas+countTareasConDemanda}} (Tareas a demanda: {{countTareasConDemanda}} y tareas no a demanda:{{countTareas}} )</h2>
                <h2>Total actividades en estado aprobadas: {{countTareasCumplidas}}</h2>
                <h2>Total actividades en estado creado: {{countTareasCreadas}}</h2>
                <h2>Total actividades en estado pendiente de aprobación: {{countTareasPendientes}}</h2>
                <h2>Total actividades en estado rechazadas: {{countTareasRechazadas}}</h2>
                <h2>Total actividades en estado incumplidas: {{countTareasIncumplidas}}</h2>

                <h2>Porcentaje aprobadas: {{ ((countTareasCumplidas*100)/countTareas).toFixed(1)}}%</h2>
                <Plotly id="pie"
                        :data="dataPie"
                        :layout="layoutPie"
                        :display-mode-bar="false">
                </Plotly>
              </div>
            </v-flex>
        </v-layout>

      <td>
        <v-btn @click="getReport" small color="primary">
          Generar reporte de actividades
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
      </td>
      <v-dialog
          v-model="dialogDownloadReportAlarm"
          max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span>Reporte generado exitosamente.</span>
          </v-card-title>
          <div align="center">
            <a :href="urlDownloadReport">Descargar Reporte</a>
          </div>

          <v-card-actions>
            <br>
            <v-btn
                color="primary"
                text
                @click="dialogDownloadReportAlarm = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<script>
    import CompanyJob from "../company/companyJob/CompanyJob";
    import Activity from "../../model/Activity";
    import { Plotly } from 'vue-plotly';

    export default {
        data() {
            return {
                idCliente: '',
                valid: true,
                activitiesConfig:[],
                idTipoExamen: '',
                fechaInicio: '',
                fechaFin: '',
                menu: false,
                menu2: false,
                idAgencia: '',
                idPuestoTrabajo: '',
                alert: false,
                dialog: false,
                search: "",
                idConfiguration: "",
                estados:['CREADO','PENDIENTE_APROBACION','APROBADO','RECHAZADO','INCUMPLIDO','TODOS'],
                estado:'',
                headers: [
                  {text: 'Fecha', value: 'date'},
                  {text: 'Compañia', value: 'company'},
                  {text: 'Actividad', value: 'actividad'},
                  {text: 'Nombre / Objetivo', value: 'code'},
                  {text: 'Descripción', value: 'code'},
                  {text: 'Estado', value: 'estado'},
                ],
                activity: new Activity(),
                dataExport: [],
                activities:[],
                countTareas:0,
                countTareasCumplidas:0,
                countTareasCreadas:0,
                countTareasPendientes:0,
                countTareasRechazadas:0,
                countTareasIncumplidas:0,
                countTareasConDemanda:0,
                chartData: [
                ['Year', 'Sales', 'Expenses', 'Profit'],
                ['2014', 1000, 400, 200],
                ['2015', 1170, 460, 250],
                ['2016', 660, 1120, 300],
                ['2017', 1030, 540, 350]
              ],
              chartOptions: {
                chart: {
                  title: 'Company Performance',
                  subtitle: 'Sales, Expenses, and Profit: 2014-2017',
                }
              },
              dataPie : [{
                values: [this.countTareas, this.countTareasCumplidas, this.countTareasCreadas,this.countTareasPendientes,this.countTareasRechazadas,this.countTareasIncumplidas],
                labels: ['Total', 'APROBADO', 'CREADO','PENDIENTE_APROBACION','APROBADO','RECHAZADO','INCUMPLIDO'],
                type: 'pie'
              }],
              layoutPie: {
                height: 400,
                width: 500
              },
              urlDownloadReport:"",
              dialogDownloadReportAlarm: false,

            }
        },
        methods: {
          changeCompany(){
            this.activitiesConfig = []
            this.activity.activityConfigurationCompany = null
            this.countTareas=0
            this.$store.dispatch('getActivityConfigurationCompanyAreEnable', this.activity.company.id).then(response => {

              for (const data of response.data) {
                if(data.months!=null && data.months!= ''){
                  data.months = JSON.parse(data.months)
                }
                if(data.questions!=null && data.questions!= ''){
                  data.questions = JSON.parse(data.questions)
                }
                if(data.trimester!=null && data.trimester!= ''){
                  data.trimester = JSON.parse(data.trimester)
                }
                data.codeName = data.code+" - "+data.name
                data.children = []
                if(data.frequency!='A DEMANDA'){
                  this.countTareas++
                }
                this.activitiesConfig.push(data)
              }

              this.activitiesConfig.push({id: 'TODOS', codeName: 'TODOS'})
            }, error => {
              this.$store.state.dialogError = true
            })
          },


            searchData() {
              if (this.$refs.form.validate()) {
                this.countTareasCumplidas=0
                this.countTareasCreadas=0,
                this.countTareasPendientes = 0
                this.countTareasRechazadas = 0
                this.countTareasIncumplidas = 0
                this.countTareasConDemanda = 0
                let searchObject={company:{id:this.activity.company.id},fechaInicio:this.fechaInicio, fechaFin: this.fechaFin, estado:(this.estado=='TODOS' ||this.estado=='') ?null:this.estado, activityConfigurationCompany: this.activity.activityConfigurationCompany.id=='TODOS'?null:{id:this.activity.activityConfigurationCompany.id}}
                this.$store.dispatch('findActivityExportProcess',searchObject).then(
                    response => {
                      this.activities = response.data
                      for (const act of this.activities) {
                        if(act.status=='APROBADO'){
                          this.countTareasCumplidas++;
                        }
                        if(act.status=='CREADO'){
                          this.countTareasCreadas++;
                        }
                        if(act.status=='PENDIENTE_APROBACION'){
                          this.countTareasPendientes++;
                        }
                        if(act.status=='RECHAZADO'){
                          this.countTareasRechazadas++;
                        }
                        if(act.status=='INCUMPLIDO'){
                          this.countTareasIncumplidas++;
                        }
                        if(act.activityConfigurationCompany.frequency=='A DEMANDA'){
                          this.countTareasConDemanda ++
                        }

                      }
                      this.dataPie = [{
                        values: [this.countTareas - this.countTareasCumplidas, this.countTareasCumplidas],
                        labels: ['Total', 'Cumplidas'],
                        type: 'pie'
                      }]
                    },
                    error => {
                      this.$store.state.dialogError = true;
                    }
                )
              }

            },
          getFormattedDate(dateReg) {
            var ua = navigator.userAgent.toLowerCase();
            var date;
            if (true) {
              // Para Safari
              if (!(dateReg instanceof Date)) {
                var b = dateReg.toString().split(/\D/);
                date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
              } else {
                date = new Date(dateReg);
              }
            } else {
              // Otros navegadores
              date = new Date(dateReg);
            }
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var hour = date.getHours();
            var min = date.getMinutes();
            var sec = date.getSeconds();
            month = (month < 10 ? "0" : "") + month;
            day = (day < 10 ? "0" : "") + day;
            hour = (hour < 10 ? "0" : "") + hour;
            min = (min < 10 ? "0" : "") + min;
            sec = (sec < 10 ? "0" : "") + sec;
            var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
            return str;
          },
          getReport() {
            this.$store.dispatch('generateReportActivitiesExcel').then(response => {
              this.$store.state.progress = false;
              this.urlDownloadReport = response.data
              this.dialogDownloadReportAlarm = true
            })
          },

        },
        watch: {
            idCliente: function (val) {
                if (val != null && val != undefined) {
                    this.getDataByIdCliente(val);
                }
            }
        },
        beforeCreate() {
            this.$store.dispatch('getCompanies').then(response => {
            }, error => {
                this.$store.state.dialogError = true
            })
        },
        created() {

        },
        components: {
            Plotly
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/activity/ActivityExportProcess.vue